import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Image, Anchor } from "hesus-ui-kit";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import phoneIcon from "@icons/ic-phone.svg";
import websiteIcon from "@icons/ic-website.svg";
import mapBlueIcon from "@icons/ic-map-marker-blue.svg";
import mapOrangeIcon from "@icons/ic-map-marker-orange.svg";
import PersonInChargeList from "../../../../PersonInCharge/PersonInChargeList/PersonInChargeList";
import CentreView from "../CentreView/CentreView";
import ClientView from "../ClientView/ClientView";
import HaulierView from "../HaulierView/HaulierView";
import Tabs from "../Tabs/Tabs";
import {
  GenrealInfo,
  Title,
  FlexRow,
  GridRow,
  SubTitle,
  DescriptionData,
  AddressInfo,
  AddressRow,
  MarginBottom,
  MapContainer,
} from "./GeneralInfo.styled";
import initMap from "@utils/map";
import { getCountryName } from "@utils/utils";
import "../../CompanyView.scss";

const GeneralInfo = (props) => {
  const { t, companyId, data, updateRefeshStatus } = props;

  const generalParams = useGetGeneralParameters();
  const [countryListAvailable, setCountryListAvailable] = useState(false);
  const [activeTab, setActiveTab] = useState(
    data?.isCentre ? "center" : data?.isClient ? "client" : "haulier"
  );
  const countries = generalParams.countryList;

  useEffect(() => {
    if (!!countries && Object.keys(countries).length > 0) {
      setCountryListAvailable(true);
    }
  }, [countries]);

  useEffect(() => {
    if (
      !!data.shippingAddress.position.latitude &&
      !!data.shippingAddress.position.longitude
    )
      initMap(
        "mapGeneral",
        data.shippingAddress.position.latitude,
        data.shippingAddress.position.longitude,
        data.billingAddress.position.latitude,
        data.billingAddress.position.longitude,
        false
      );
  }, []);

  const getWebsiteLink = (link) => {
    if (link !== null && link !== "") {
      return link.startsWith("http://") || link.startsWith("https://")
        ? link
        : `http://${link}`;
    }
  };

  useEffect(() => {
    if (data?.isHaulier) setActiveTab("haulier");
    if (data?.isCentre) setActiveTab("center");
    if (data?.isClient) setActiveTab("client");
  }, [data]);

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <GenrealInfo>
        <FlexRow column="1fr">
          <Title>{t("GENERAL_INFORMATION")}</Title>
        </FlexRow>
        <GridRow column="1fr 1fr">
          <div>
            <FlexRow>
              <SubTitle>{t("COMPANY_REGISTRATION_NUMBER")} :</SubTitle>
              <SubTitle color="#767676" paddingLeft="10px">
                {data.identificationNumber !== null
                  ? data.identificationNumber
                  : ""}
              </SubTitle>
            </FlexRow>
            <FlexRow>
              <SubTitle>{t("COMPANY_ACTIVITY")} :</SubTitle>
              <SubTitle color="#767676" paddingLeft="10px">
                {data.activity?.name}
              </SubTitle>
            </FlexRow>
          </div>
          <div>
            <FlexRow>
              <Image
                src={phoneIcon}
                alt={t("PHONE")}
                title={t("PHONE")}
                className="company-centre-view__image-icon-communication"
              />
              <SubTitle color="#767676" paddingLeft="10px">
                {data.phone}
              </SubTitle>
            </FlexRow>
            <FlexRow>
              <Image
                src={websiteIcon}
                alt={t("WEBSITE")}
                title={t("WEBSITE")}
                className="company-centre-view__image-icon-communication"
              />
              <SubTitle color="#767676" paddingLeft="10px">
                <Anchor
                  url={getWebsiteLink(data.website)}
                  rel="noreferrer"
                  target="_blank"
                  className="company-centre-view__link"
                >
                  {data.website}
                </Anchor>
              </SubTitle>
            </FlexRow>
          </div>
        </GridRow>
        <GridRow column="1fr">
          <SubTitle marginBottom="5px">{t("ADDITIONAL_INFORMATION")}</SubTitle>
        </GridRow>
        <DescriptionData>
          <div
            dangerouslySetInnerHTML={{
              __html: data.comment,
            }}
          ></div>
        </DescriptionData>

        <FlexRow column="1fr">
          <Title>{t("ADDRESSES")}</Title>
        </FlexRow>
        <GridRow column="1fr 1fr 1fr">
          <AddressRow>
            <SubTitle marginBottom="10px">
              <Image
                src={mapBlueIcon}
                alt={t("BILLING_ADDRESS")}
                title={t("BILLING_ADDRESS")}
                className="company-centre-view__image-icon-map"
              />
              {t("SHIPPING_ADDRESS")} :
            </SubTitle>
            <AddressInfo color="#767676" paddingLeft="10px">
              {data.shippingAddress.street ? data.shippingAddress.street : ""}
            </AddressInfo>
            {parseInt(data.shippingAddress.country, 10) === 1 && (
              <>
                <AddressInfo color="#767676" paddingLeft="10px">
                  {data.shippingAddress.city
                    ? " " + data.shippingAddress.city
                    : ""}
                  {data.shippingAddress.postalCode
                    ? ", " + data.shippingAddress.postalCode
                    : ""}
                </AddressInfo>
              </>
            )}

            {parseInt(data.shippingAddress.country, 10) !== 1 && (
              <>
                <AddressInfo color="#767676" paddingLeft="10px">
                  {data.shippingAddress.postalCode
                    ? data.shippingAddress.postalCode + ", "
                    : ""}
                  {data.shippingAddress.city
                    ? " " + data.shippingAddress.city
                    : ""}
                </AddressInfo>
              </>
            )}
            <AddressInfo color="#767676" paddingLeft="10px">
              {countryListAvailable && data.shippingAddress.country
                ? getCountryName(
                    parseInt(data.shippingAddress.country, 10),
                    countries
                  )
                : ""}
            </AddressInfo>
            <MarginBottom />
            <SubTitle marginBottom="10px">
              <Image
                src={mapOrangeIcon}
                alt={t("BILLING_ADDRESS")}
                title={t("BILLING_ADDRESS")}
                className="company-centre-view__image-icon-map"
              />
              {t("BILLING_ADDRESS")} :
            </SubTitle>
            <AddressInfo color="#767676" paddingLeft="10px">
              {data.billingAddress.street ? data.billingAddress.street : ""}
            </AddressInfo>
            {parseInt(data.billingAddress.country, 10) === 1 && (
              <>
                <AddressInfo color="#767676" paddingLeft="10px">
                  {data.billingAddress.city
                    ? data.billingAddress.city + ", "
                    : ""}
                  {data.billingAddress.postalCode
                    ? data.billingAddress.postalCode
                    : ""}
                </AddressInfo>
              </>
            )}

            {parseInt(data.billingAddress.country, 10) !== 1 && (
              <>
                <AddressInfo color="#767676" paddingLeft="10px">
                  {data.billingAddress.postalCode
                    ? data.billingAddress.postalCode + ", "
                    : ""}
                  {data.billingAddress.city
                    ? " " + data.billingAddress.city
                    : ""}
                </AddressInfo>
              </>
            )}
            <AddressInfo color="#767676" paddingLeft="10px">
              {countryListAvailable && data.billingAddress.country
                ? getCountryName(
                    parseInt(data.billingAddress.country, 10),
                    countries
                  )
                : ""}
            </AddressInfo>
          </AddressRow>
          <div>
            {!!data.shippingAddress.position.latitude &&
              !!data.shippingAddress.position.longitude && (
                <MapContainer id="mapGeneral" />
              )}
          </div>
        </GridRow>
      </GenrealInfo>
      <Tabs toggleTab={toggleTab} data={data} activeTab={activeTab} />
      {data.isClient && activeTab === "client" && (
        <ClientView data={data} updateRefeshStatus={updateRefeshStatus} />
      )}
      {data.isCentre && activeTab === "center" && (
        <CentreView data={data.centre} />
      )}
      {data.isHaulier && activeTab === "haulier" && (
        <HaulierView data={data.haulier} />
      )}
      <PersonInChargeList
        objectId={companyId}
        objectType="company"
        columnName="companyId"
      />
    </>
  );
};
GeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(GeneralInfo);
